import { GridLayout } from "src/app/classes/widget/dashboard-grid";
import { Chart, WidgetV2 } from "./chart";
import { User } from "./user";

export interface PostDashboard {
    title?: string;
    description?: string;
    owner?: User | string;
    users?: string[];
    charts?: (Chart | string)[];
    projects?: string[];
    projectSettings?: {
        title?: string;
        project: string;
        mailingList: string[];
        startDate?: string | number;
        endDate?: string | number;
        units?: string[];
        reportFrequency: "never" | "daily" | "weekly" | "monthly";
        index?: number;
    }[];
    accessKey?: string;
    autoRefresh?: {
        unit: "minute" | "hour" | null;
        value?: number;
    };
}

export interface PutDashboard {
    id: string;
    title?: string;
    description?: string;
    owner?: User | string;
    users?: string[];
    charts?: (Chart | string)[];
    projects?: string[];
    projectSettings?: {
        title?: string;
        project: string;
        mailingList: string[];
        startDate?: string | number;
        endDate?: string | number;
        units?: string[];
        reportFrequency: "never" | "daily" | "weekly" | "monthly";
        index?: number;
    }[];
    accessKey?: string;
    autoRefresh?: {
        unit: "minute" | "hour" | null;
        value?: number;
    };
}

export type SynthesisTheme = 'prevention' | 'production' | 'safety' | 'environment';

export const SYNTHESIS_THEMES: readonly SynthesisTheme[] = ['prevention', 'production', 'safety', 'environment'];

// GET /dashboards/company/:companyId/:theme — created empty on first access.
export interface CompanyDashboard {
    id: string;
    title: string;
    company: string;
    theme: SynthesisTheme;
    charts: WidgetV2[];     // populated, in order
    layout?: GridLayout;    // absent until first change
    canEdit: boolean;       // dev/admin, or userAdmin of the company
}

// Widget editor opened from a synthesis: data of the whole tenant, saved on the company dashboard.
export interface WidgetEditorScope {
    companyId: string;
    tenantId: string;
    theme: SynthesisTheme;
}
